document.addEventListener('DOMContentLoaded', function () {

  //--------------- Index real people real story js code -----------------
  const realStoriesSlider = document.querySelector('#realStoriesSlider');
  if (realStoriesSlider && typeof Splide !== 'undefined') {
    new Splide(realStoriesSlider, {
      type: 'slide',
      perPage: 5,
      perMove: 1,
      gap: '36px',
      arrows: true,
      pagination: false,
      speed: 800,
      breakpoints: {
        1600: {
          perPage: 4,
           gap: '20px'
        },
        1199: {
          perPage: 3
        },
        767: {
          perPage: 2
        },
        575: {
          perPage: 1,
          gap: '12px'
        }
      }
    }).mount();

  }

  //--------------- index testimonial slider------------------
  const sliderEl = document.querySelector('#testimonial-slider');

  if (sliderEl) {
    new Splide(sliderEl, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '20px',
      arrows: true,
      pagination: false,
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 800,
      easing: 'ease',
    }).mount();
  }

});


// -------------------index before after js code-------------------
document.addEventListener('DOMContentLoaded', function () {

  // Guard: only run if before-after sliders exist on this page
  const sliders = document.querySelectorAll('.before-after-slider');
  if (!sliders.length) return;

  sliders.forEach((sliderEl) => {
    const splide = new Splide(sliderEl, {
      type: 'slide',
      perPage: 3,
      gap: '26px',
      arrows: true,
      pagination: false,
      autoplay: false,
      drag: false,
      breakpoints: {
        1024: {
          perPage: 2,
          gap: '15px'
        },
        767: { 
          perPage:1
        }
      },
    });

    // Hide arrows based on perPage count
    const toggleArrows = () => {
      const perPage = splide.options.perPage;

      const arrows = sliderEl.querySelectorAll('.splide__arrow');
      const slidesCount = splide.length;

      // hide arrows if all slides fit in view
      if (slidesCount <= perPage) {
        arrows.forEach(arrow => (arrow.style.display = 'none'));
      } else {
        arrows.forEach(arrow => (arrow.style.display = ''));
      }
    };
    splide.on('mounted moved resized', toggleArrows);

    splide.mount();

    sliderEl.querySelectorAll('.img-compare').forEach((container) => {
      const imgBefore    = container.querySelector('.img-before');         // clips the image (drives the reveal)
      const beforeWrapper = container.querySelector('.img-before-wrapper'); // clips the wrapper (hides the label)
      const handle       = container.querySelector('.slider-handle');

      if (!imgBefore || !beforeWrapper || !handle) return;

      const startPct = parseFloat(container.dataset.start) || 50;

      // Set initial position
      applyPosition(imgBefore, beforeWrapper, handle, startPct);

      container.addEventListener('pointerdown', (e) => {
        const handleRect = handle.getBoundingClientRect();
        const hitZone    = 30;
        const nearHandle = Math.abs(e.clientX - (handleRect.left + handleRect.width / 2)) < hitZone;

        // Let Splide handle swipes that start away from the handle
        if (!nearHandle) return;

        e.stopPropagation();
        e.preventDefault();
        container.setPointerCapture(e.pointerId);

        move(e.clientX);

        const onMove = (ev) => {
          ev.stopPropagation();
          move(ev.clientX);
        };

        const onUp = (ev) => {
          ev.stopPropagation();
          container.releasePointerCapture(ev.pointerId);
          container.removeEventListener('pointermove', onMove);
          container.removeEventListener('pointerup', onUp);
        };

        container.addEventListener('pointermove', onMove);
        container.addEventListener('pointerup', onUp);

        function move(x) {
          const rect = container.getBoundingClientRect();
          let pct = ((x - rect.left) / rect.width) * 100;
          pct = Math.max(0, Math.min(100, pct));
          applyPosition(imgBefore, beforeWrapper, handle, pct);
        }
      });
    });
  });

  /**
   * Applies the slider position.
   * - clips imgBefore  → drives the actual image reveal
   * - clips beforeWrapper → hides the "Before" label along with the image
   * - moves handle      → visual drag indicator
   */
  function applyPosition(imgBefore, beforeWrapper, handle, pct) {
    const clip = `inset(0 ${100 - pct}% 0 0)`;
    imgBefore.style.clipPath    = clip; // image reveal
    beforeWrapper.style.clipPath = clip; // label reveal
    handle.style.left           = pct + '%';
  }
  

});

// Artcle Faq
document.querySelectorAll('.custom-article-faq .ques').forEach(function(question){
    question.addEventListener('click', function(){
        var item = this.parentElement;
        document.querySelectorAll('.artfaq-item.active')
        .forEach(function(activeItem){
            if(activeItem !== item){
                activeItem.classList.remove('active');
            }
        });
        item.classList.toggle('active');
    });

});